<a class="floating-block" *ngIf="layout && layout.floatingBlock && layout.floatingBlock.visible" [routerLink]="layout.floatingBlock.url">
  {{ layout.floatingBlock.text }}
</a>
